/** Image file types */
export const IMAGE_FILE_TYPES = ['png', 'jpg', 'jpeg', 'webp'];
